<div id="login-root">
    <div id="login-box" class="box">
        <div class="box-header">Log-in as existing user</div>
        <div class="box-content">
            <form class="login-container">
                <label class="left">Username: </label>
                <input class="right" id="input-login-username" type="text" name="username" autocomplete="username" required>
                <label class="left">Password: </label>
                <input class="right" id="input-login-password" type="password" name="password" autocomplete="current-password" required>
                <button type="submit" class="left" id="button-login">Login</button>
                <span id="label-login-message" class="label right"></span>
            </form>
        </div>
    </div>
    <div id="register-box" class="box">
        <div class="box-header">Register new user</div>
        <div class="box-content">
            <form class="register-container">
                <label class="left">Username: </label>
                <input class="right" id="input-register-username" type="text" autocomplete="username" required>
                <label class="left">Email: </label>
                <input class="right" id="input-register-email" type="text" autocomplete="email" required>
                <label class="left">Password: </label>
                <input class="right" id="input-register-password" type="password" autocomplete="new-password" required>
                <label class="left">Confirm Password: </label>
                <input class="right" id="input-register-password-confirm" type="password" autocomplete="new-password" required>
                <button type="submit" class="left" id="button-register">Register</button>
                <span id="label-register-message" class="label right"></span>
            </form>
        </div>
    </div>
</div>